import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../components/UI/Button";
import ConfirmationDialog from "../components/ConfirmationDialog";
import Notification from "../components/Notification";
import CountryPaymentGatewaySearch from "../components/countryPaymentGateway/CountryPaymentGatewaySearch";
import CountryPaymentGatewayTable from "../components/countryPaymentGateway/CountryPaymentGatewayTable";
import CountryPaymentGatewayFormModal from "../components/countryPaymentGateway/CountryPaymentGatewayFormModal";
import { getCountryPaymentGateways, removeCountryPaymentGateway, } from "../redux/countryPaymentGatewaySlice";
import PageSizeSelector from "../components/PageSizeSelector";

const CountryPaymentGateways = () => {
    const dispatch = useDispatch();
    const { countryPaymentGateways, pagination, status, } = useSelector((state) => state.countryPaymentGateways);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const loadData = () => {
        dispatch(
            getCountryPaymentGateways({
                page,
                page_size: pageSize,
                search,
            })
        );
    };

    useEffect(() => {
        loadData();
    }, [page, pageSize]);

    const handleSearch = (value) => {
        setSearch(value);
        setPage(1);
        dispatch(
            getCountryPaymentGateways({
                page: 1,
                page_size: pageSize,
                search: value,
            })
        );
    };

    const handlePageSizeChange = (e) => {
        setPageSize(Number(e.target.value));
        setPage(1);
    };

    const handleAdd = () => {
        setSelectedRow(null);
        setShowModal(true);
    };

    const handleEdit = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const handleDelete = (row) => {
        setSelectedRow(row);
        setShowDelete(true);
    };

    const confirmDelete = async () => {
        await dispatch(removeCountryPaymentGateway(selectedRow.id));
        setShowDelete(false);
        loadData();
    };

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col justify-between gap-4 rounded-2xl border border-slate-200 bg-white p-6 sm:flex-row sm:items-center">
                <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <rect x="2" y="5" width="20" height="14" rx="2.5" />
                            <path d="M2 9.5h20" strokeLinecap="round" />
                        </svg>
                    </div>

                    <div>
                        <h1 className="text-2xl font-bold tracking-tight text-slate-900">
                            Country Payment Gateways
                        </h1>

                        <p className="mt-1 text-sm text-slate-500">
                            Configure payment gateways available for each country.
                        </p>
                    </div>
                </div>

                <Button onClick={handleAdd} className="shrink-0">
                    + Add Configuration
                </Button>
            </div>

            {/* Search + page size */}
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <CountryPaymentGatewaySearch
                    search={search}
                    onSearch={handleSearch}
                />

                <PageSizeSelector
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                />
            </div>

            {/* Table */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6">
                <CountryPaymentGatewayTable
                    data={countryPaymentGateways}
                    loading={status === "loading"}
                    pagination={pagination}
                    onPageChange={setPage}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                />
            </div>

            {/* Form Modal */}
            <CountryPaymentGatewayFormModal
                open={showModal}
                onClose={() => {
                    setShowModal(false);
                    loadData();
                }}
                data={selectedRow}
                reload={loadData}
                existingConfigurations={countryPaymentGateways}
            />

            {/* Delete */}
            <ConfirmationDialog
                isOpen={showDelete}
                message={`Delete configuration for ${selectedRow?.country_name}?`}
                onCancel={() => setShowDelete(false)}
                onConfirm={confirmDelete}
            />

            {/* <Notification /> */}
        </div>
    );
};

export default CountryPaymentGateways;